<template>
  <Card class="page-patientConfig">
    <div class="quest-titles" style="text-align: right; margin-bottom: 15px">
      <el-button
        type="primary"
        round
        class="creatBtn"
        @click="addLabel"
        style="background: #4286f1;"
      >新增标签</el-button>
    </div>

    <Table :columns="columns" :data="list" :loading="loading">
      <template slot-scope="{row}" slot="name">
        <template>{{row.name}}</template>
      </template>
      <template slot-scope="{row}" slot="create_time">
        <template>{{row.create_time}}</template>
      </template>
      <template slot-scope="{row, index}" slot="action">
        <caring-button @click="edit(row, index)">编辑</caring-button>
        <caring-button @click="del(row, index)">删除</caring-button>
      </template>
    </Table>
    <div style="margin-top:16px;text-align:right;">
      <Page
        :total="total"
        :current="current"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>

    <Modal v-model="modalShow" width="500">
      <div slot="header" style="text-align: center">
        <span>{{title}}</span>
      </div>
      <Form
        :model="curModule"
        :label-width="120"
        :rules="moduleRule"
        label-position="right"
        ref="ruleForm"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="标签名称" required prop="name">
          <Input v-model.trim="curModule.name" :maxlength="20" placeholder="请填写标签名称"></Input>
        </FormItem>
        <!-- <FormItem label="颜色配置" prop="color" style="width:500px">
          <el-input type="color" autosize placeholder="请输入内容" v-model="curModule.color"></el-input>
        </FormItem>-->
        <FormItem label="颜色配置" class="colorpz" prop="color" style="width:470px;">
          <color-select :color-list="colorList" v-model="curModule.color"></color-select>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelModule">取消</el-button>
        <el-button type="primary" round @click="saveModule('ruleForm')">保存</el-button>
      </div>
    </Modal>
  </Card>
</template>
<script>
import { getTag, addTag, deleteTagApi } from '../../api/tag'
import colorSelect from './components/colorSelect'
import { Message, MessageBox } from 'element-ui'
export default {
  data() {
    return {
      //颜色初始数据
      colorList: [
        '#c17dfb',
        '#529ff5',
        '#39bc64',
        '#fa7070',
        '#f5b10d',
        '#2fb778',
        '#6e84f3',
        '#fea100',
      ],
      total: 0,
      current: 1,
      size: 10,
      sizes: [5, 10, 30, 40],
      columns: [
        {
          title: '标签名',
          slot: 'name',
          align: 'center',
        },
        {
          title: '创建时间',
          slot: 'create_time',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 200,
          align: 'center',
        },
      ],
      list: [],
      loading: true,
      modalShow: false,
      title: '新增标签',
      oktext: '确定',
      value: '',
      curModule: {
        name: '',
        color: '#c17dfb',
      },
      moduleRule: {
        name: [
          {
            required: true,
            message: '请填写标签名称',
            trigger: 'blur',
          },
        ],
      },
      id: '',
      type: '0', //0：筛选 1：慢病
    }
  },
  components: {
    colorSelect,
  },
  created() {
    this.getTagList()
  },
  methods: {
    getTagList: function () {
      let type = this.type
      let page = this.current
      let size = this.size
      let need_page = 1
      getTag({ type, page, size, need_page }).then((res) => {
        this.loading = false
        if (res.code === 0) {
          // console.log(res)
          let list = res.data
          this.list = list
          this.total = Number(res['x-total-count'])
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    onCurrentChange: function (current) {
      this.current = current
      this.getTagList()
    },
    onSizeChange: function (size) {
      this.size = size
      this.getTagList()
    },
    addLabel: function () {
      this.modalShow = !this.modalShow
      this.title = '新增标签'
      this.isAdd = true
      this.curModule.name = ''
      this.curModule.color = '#c17dfb'
    },
    edit: function (row, index) {
      console.log(row)
      this.id = row.id
      this.modalShow = !this.modalShow
      this.title = '编辑标签'
      this.isAdd = false
      this.curModule.name = row.name
      if (!this.colorList.includes(row.color)) {
        this.colorList.push(row.color)
      }
      this.curModule.color = row.color
    },
    del: function (row) {
      MessageBox.confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        deleteTagApi(row.id).then((res) => {
          if (res.code === 0) {
            // console.log(res)
            this.$Message.success('删除成功')
            const totalPage = Math.ceil((this.total - 1) / this.size) // 总页数
            this.current = this.current > totalPage ? totalPage : this.current
            this.current = this.current < 1 ? 1 : this.current
            this.getTagList()
          } else {
            this.$Message.error(res.message)
          }
        })
      })
    },
    cancelModule: function () {
      this.modalShow = false
    },
    saveModule: function (formName) {
      console.log(this.curModule)
      let name = this.curModule.name
      let color = this.curModule.color
      let type = this.type
      let obj = {
        name: name,
        type: type,
        color: color,
      }
      if (!this.isAdd) {
        obj = {
          id: this.id,
          name: name,
          type: type,
          color: color,
        }
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          addTag(obj).then((res) => {
            if (res.code === 0) {
              // console.log(res)
              this.$Message.success('新增成功')
              this.modalShow = !this.modalShow
              this.getTagList()
            } else {
              this.$Message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
</style>
